// extracted by mini-css-extract-plugin
export default {"image":"WX-z","loaded":"XX-z"};